import React, { Component, PropTypes } from 'react';
import { hexToRgba, Units, Colors } from 'Css';
import classNames from 'classnames';
import * as SvgIcons from 'components/Material/SvgIcons';
import { StoreOverviewActions } from 'actions';
import DragSource from 'react-dnd/lib/DragSource';

const css = oxygenCss({
  root: {
    position: 'relative',
    textAlign: 'center',
    lineHeight: `${Units.keyline}px`,
    backgroundColor: '#F0F0F0',
    height: Units.keyline,
    cursor: 'pointer',
    boxSizing: 'border-box',
    '&selected': {
      backgroundColor: '#d7f6f7',
      border: `solid 2px ${Colors.creen}`,
      color: Colors.creen
    },
    '>SVG': {
      verticalAlign: 'middle'
    },
    '&isOver': {
      border: `solid 2px ${hexToRgba(Colors.creen, 20)} !important`,
      backgroundColor: `${hexToRgba(Colors.creen, 50)} !important`
    },
    '&isDragging': {
      opacity: 0.25,
      border: `solid 2px ${hexToRgba(Colors.creen, 10)} !important`,
      backgroundColor: `${hexToRgba(Colors.creen, 25)} !important`
    }
  },
  settingsIcon: {
    position: 'absolute',
    right: Units.base / 2,
    top: Units.base / 2
  }
});

const styles = {
  icon: {
    width: Units.base * 4,
    height: Units.base * 4
  },
  settingsIcon: {
    width: Units.base * 2,
    height: Units.base * 2
  }
};

const icons = {
  Text: SvgIcons.EditorFormatAlignLeft,
  Banner: SvgIcons.ImageLandscape,
  Image: SvgIcons.ImageImage,
  Video: SvgIcons.AvMovie,
  List: SvgIcons.ImageViewComfy,
  Filter: SvgIcons.ContentFilterList
};

const dragSource = {
  beginDrag(props) {
    return {
      id: props.id,
      sectionId: props.sectionId,
      type: props.type
    };
  },
  endDrag(props, monitor) {
    props.endDrag(monitor.getItem(), monitor.didDrop());
  }
};

class StoreLayoutOverviewColumn extends Component {
  static propTypes = {
    type: PropTypes.string,
    selected: PropTypes.bool,
    id: PropTypes.string,
    columnCount: PropTypes.number,
    // react-dnd props
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    connectDragPreview: PropTypes.func,
    endDrag: PropTypes.func,
    onDrop: PropTypes.func,
    isDragging: PropTypes.bool,
    isOver: PropTypes.bool
  };

  select = () => {
    const { id } = this.props;
    StoreOverviewActions.selectModule(id);
  };

  render() {
    const { selected, type, isOver, isDragging, ...other } = this.props;
    const classes = classNames(css.root, {
      [css.selected]: selected,
      // [css.isOver]: isOver,
      [css.isDragging]: isDragging
    });
    const Icon = icons[type];
    let content = (
      <div className={classes} onTouchTap={this.select}>
        <Icon style={styles.icon} color={selected ? Colors.creen : '#777777'} />
        {selected && (
          <SvgIcons.ActionSettings
            style={styles.settingsIcon}
            className={css.settingsIcon}
            color={Colors.creen}
          />
        )}
      </div>
    );

    // Connect as drag source
    content = this.props.connectDragSource(content, { dropEffect: 'move' });
    // Connect to drag layer
    content = this.props.connectDragPreview(content);

    return content;
  }
}

export default DragSource('StoreColumn', dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}))(StoreLayoutOverviewColumn);



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/LayoutOverview/StoreLayoutOverviewColumn.js